module.exports = __webpack_public_path__ + "img/DSC_7727.32dbfbe0.jpg";